import { NcassUser } from "../models/auth0/NcassUser";

export const isRenewOnlyMember = (user?: NcassUser): boolean => (
    user !== undefined
    && (user.ncassAccountStatus === 'Expired' || user.ncassAccountStatus === 'Archived' || user.ncassAccountStatus === 'Cancelled')
    && user["http://ncass.org.uk/memberType"] === 'Caterer'
);
